import { Theme } from '@api/tenantApi/interfaces';
import { createTheme } from '@mui/material/styles';

export function createTenantTheme(themeConfig: Theme) {
  return createTheme({
    palette: {
      primary: {
        main: themeConfig.colors?.primary || '#12900b',
      },
      secondary: {
        main: themeConfig.colors?.secondary || '#ce0823',
      },
      default: {
        main: 'rgba(0, 0, 0, 0.54)',
        contrastText: '#000',
      },
      light: {
        main: '#f1f2f6',
        contrastText: '#747d8c',
      },
      // primary: {
      //   light: '#757ce8',
      //   main: '#3f50b5',
      //   dark: '#002884',
      //   contrastText: '#fff',
      // },
      // secondary: {
      //   light: '#ff7961',
      //   main: '#f44336',
      //   dark: '#ba000d',
      //   contrastText: '#000',
      // },
    },

    typography: {
      h1: {
        fontSize: '2.2rem',
        fontWeight: 500,
        color: '#262626',
      },
    },

    components: {
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            textTransform: 'none',
            fontWeight: 'bold',
            ...(ownerState.color === 'default' && {
              color: 'rgba(0, 0, 0, 0.54)',
              backgroundColor: 'transparent',
              borderColor: 'rgba(0, 0, 0, 0.23)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }),
          }),
        },
      },
    },

    portal: {
      maxWidth: '1400px',
      sidebar: {
        width: '250px',
      },
    },
  });
}
